import React from 'react';

import { Layout } from '../../components';
import FeedsHeader from './FeedsHeader';
import FeedsList from './FeedsList';

const Feeds = () => {
    const headerProps = {
        isTransparent: false,
        children: <FeedsHeader />,
    };

    return (
        <Layout headerProps={headerProps} isTopMargin>
            <FeedsList />
        </Layout>
    );
};

export default Feeds;
